<template>
    <div class="add-delete-button-wrapper">
        <button :class="[cssClass, {'will-delete': willDelete}]"
                :title="willDelete ? 'Delete Swatch' : 'Add Swatch'"
                @click="addSwatch">
            <icon-trash></icon-trash>
        </button>
        <container class="add-button-container" @drop="drop" @drag-enter="enter" @drag-leave="leave" group-name="swatches" />
    </div>
</template>

<script>
    import { Container }     from "vue-smooth-dnd";
    import IconTrash         from "../../../../../Lib/Icons/IconTrash";
    import UsesActivePalette from "./UsesActivePalette";
    import Swatch      from "../../../Swatch";
    import DraftSwatch from "../../../Store/DraftSwatch";

    export default {
        name: "AddSwatchButton",

        extends: UsesActivePalette,

        components: {
            IconTrash,
            Container,
        },

        props: {
            isDragging: {},
        },

        computed: {
            cssClass() {
                return this.isDragging ? 'remove' : 'add';
            },

        },

        data() {
            return {
                willDelete: false,
                draftSwatch: new DraftSwatch(),
            }
        },

        methods: {
            addSwatch() {
                let swatch = JSON.parse(JSON.stringify(new Swatch({name: 'New Swatch', color: this.draftSwatch.rgb()})));
                this.swatches.push(swatch);
                this.activePalette.activate(this.palette.id, this.activePalette.getSwatchCount() - 1);
                this.$router.push({name: 'colors'});
            },

            enter() {
                this.$emit('willDeleteStatusChanged', this.willDelete);
                this.willDelete = true;
            },

            leave() {
                this.willDelete = false;
            },

            drop({addedIndex, payload: swatch}) {
                let swatchCount = this.activePalette.getSwatchCount();
                if(addedIndex == null || swatchCount === 1) return;
                let isRemovingLastSwatch = swatch.index === swatchCount - 1;

                this.swatches.remove(swatch.index);

                if(isRemovingLastSwatch) {
                    this.activePalette.activate(this.palette.id, 0);
                }

                this.willDelete = false;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .add-delete-button-wrapper {
        width: 4rem;
        height: 4rem;
    }
    .add-button-container {
        width: 4rem;
        height: 4rem;
        position: absolute;
        right: 0;
        z-index: -1;
    }

    button {
        position: relative;
        transition: all 0.2s ease-in-out;

        svg.icon-trash {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -14px auto auto -14px;
            width: 28px;
            height: 28px;
            fill: #fff;
            transition: all 0.2s ease-in-out;
        }
    }

    .add {
        svg.icon-trash {
            opacity: 0;
            visibility: hidden;
        }
    }

    .remove {
        min-width: unset;
        padding: 1em;
        font-size: 1.4em;
        background-color: #fc2c2e;
        border-color: transparent;

        svg.icon-trash {
            opacity: 1;
            visibility: visible;
        }
    }

    .will-delete {
        transform: scale(1.25);
        border-radius: 5px !important;
        border-left: none !important;
    }
</style>
